import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import emailjs from '@emailjs/browser';
import '../css/LeaveReview.css';
import Footer from './footer/Footer';
import Header from '../components/Header';

const EMAILJS_SERVICE_ID = 'service_yeelmvu';
const EMAILJS_REVIEW_TEMPLATE_ID = 'template_9qwjteb';
const EMAILJS_PUBLIC_KEY = 'JAExh2BmxCEgxx9oA';

const LeaveReview = () => {
    const [formData, setFormData] = useState({ name: '', rating: 5, text: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleRatingChange = (rating) => {
        setFormData(prev => ({ ...prev, rating }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const templateParams = {
                name: formData.name,
                rating: formData.rating,
                review_text: formData.text
            };

            await emailjs.send(
                EMAILJS_SERVICE_ID,
                EMAILJS_REVIEW_TEMPLATE_ID,
                templateParams,
                EMAILJS_PUBLIC_KEY
            );

            setSubmitStatus('success');
            setFormData({ name: '', rating: 5, text: '' });
        } catch (error) {
            console.error('Erreur lors de l\'envoi de l\'avis:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Laisser un avis - CC Débarras 14</title>
                <meta name="description" content="Vous n'avez pas de compte Google ? Laissez votre avis sur CC Débarras 14 directement depuis notre site." />
                <link rel="canonical" href="https://ccdebarras14.fr/laisser-un-avis" />
            </Helmet>

            <Header />

            <div className="leave-review-component">
                <div className="leave-review-content">
                    <div className="leave-review-header">
                        <h1>Laisser un avis</h1>
                        <p>
                            Vous n'avez pas de compte Google ? Pas de problème, partagez votre expérience
                            directement ici. Votre avis sera publié sur notre page d'accueil après validation.
                        </p>
                    </div>

                    <form className="leave-review-form" onSubmit={handleSubmit}>
                        <div className="leave-review-form-group">
                            <label htmlFor="review-name">Votre nom *</label>
                            <input
                                type="text"
                                id="review-name"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                required
                                placeholder="Votre nom ou prénom"
                            />
                        </div>

                        <div className="leave-review-form-group">
                            <label>Votre note *</label>
                            <div className="leave-review-form-stars">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        type="button"
                                        key={star}
                                        className={`leave-review-form-star ${star <= formData.rating ? 'active' : ''}`}
                                        onClick={() => handleRatingChange(star)}
                                        aria-label={`${star} étoile${star > 1 ? 's' : ''}`}
                                    >
                                        ★
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="leave-review-form-group">
                            <label htmlFor="review-text">Votre avis *</label>
                            <textarea
                                id="review-text"
                                name="text"
                                value={formData.text}
                                onChange={handleInputChange}
                                required
                                rows="6"
                                placeholder="Partagez votre expérience avec CC Débarras 14..."
                            ></textarea>
                        </div>

                        <button
                            type="submit"
                            className="leave-review-form-submit"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Envoi en cours...' : 'Envoyer mon avis'}
                        </button>

                        {submitStatus === 'success' && (
                            <div className="leave-review-form-success">
                                ✅ Merci pour votre avis ! Il sera publié sur le site après validation.
                            </div>
                        )}

                        {submitStatus === 'error' && (
                            <div className="leave-review-form-error">
                                ❌ Une erreur s'est produite lors de l'envoi. Veuillez réessayer plus tard.
                            </div>
                        )}
                    </form>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default LeaveReview;
